/**
 * Общее окно обрезки изображений (CropperJS): создаёт Bootstrap-модалку на лету через openModalWindow,
 * поэтому всегда открывается поверх остальных окон. Окно собирается заново при каждом открытии и
 * удаляется из DOM после закрытия — статических модалок в разметке больше нет.
 * Используются avatar.js (аватар) и image-upload.js (изображения проектов).
 */

window.openCropperWindow = function (imageSrc, options) {
    // options.title          — заголовок окна (обязательно).
    // options.cropperOptions — параметры CropperJS для этой картинки (обязательно).
    // options.onSave(cropper, config, hideLoadBox) — обработчик «Применить»: выполнить сохранение и вызвать hideLoadBox(), когда готово.
    // options.onAfterClose(config) — необязательный хук после закрытия окна.

    window.openModalWindow(null, {
        title: options.title || 'Настройка изображения',
        size: "lg",
        content: '<div class="img-container" style="max-height: 450px; overflow: hidden;"><img class="cropper-window-image" src="' + imageSrc + '" alt="" style="display: block; max-width: 100%;"></div>',
        buttons: [
            {label: "Отмена", classes: "btn-secondary fw-bold me-2", onClick: "modal-hide"},
            {label: "Применить", classes: "btn-primary fw-bold", onClick: applyCrop}
        ],
        // Инициализация только после shown.bs.modal: Bootstrap 5.3 делает модалку видимой лишь после fade-in бэкдропа,
        // а CropperJS меряет контейнер при старте — в скрытом окне offsetWidth = 0 и кроппер «запекается» на MIN_CONTAINER_WIDTH (200px).
        onAfterOpen: function (config) {
            initCropper(config, options);
        },
        onBeforeClose: function (config) {
            if (config.cropper) {
                config.cropper.destroy();
                config.cropper = null;
            }
        },
        onAfterClose: typeof options.onAfterClose === "function" ? options.onAfterClose : null
    });

    /** Кнопка «Применить» в футере: показывает индикатор «Обработка...» и передаёт управление options.onSave. */
    function applyCrop(button, config) {
        let cropper = config.cropper;
        if (!cropper) return;

        let loadBox = jQuery('<div class="load-box me-auto" style="display: none;"><i class="fas fa-spinner fa-spin text-primary me-2"></i> <span class="small">Обработка...</span></div>').prependTo(config.modal.find(".modal-footer"));
        loadBox.show();

        options.onSave(cropper, config, function () {
            loadBox.hide();
        });
    }

    /** Инициализация CropperJS на картинке окна после её загрузки. */
    function initCropper(config, options) {
        let imageEl = config.modal.find(".cropper-window-image")[0];
        if (!imageEl) return;

        let start = function () {
            config.cropper = new window.Cropper(imageEl, options.cropperOptions);
        };

        if (imageEl.complete && imageEl.naturalWidth !== 0) {
            start();
        } else {
            imageEl.onload = start;
        }
    }
};
